var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1SocketG(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 38a4.5 4.5 0 114.5 4.5 4.491 4.491 0 01-4.5-4.5zm-23 4.5a4.5 4.5 0 10-4.5-4.5 4.49 4.49 0 004.5 4.5zM7 38a31 31 0 1162.001 0A31 31 0 017 38zm3.76 0A27.28 27.28 0 0035 65.07V53h6v12.07a27.24 27.24 0 000-54.14V24h-6V10.93A27.28 27.28 0 0010.76 38z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Socket_G.6299c3f3.svg";
export { SvgA1SocketG as ReactComponent };